export default __webpack_public_path__ + "static/media/10.a435bd40.svg";